import { createSlice } from '@reduxjs/toolkit';
import { ConnectedDevice } from '../../../helper/cloudcore/response/models/body';

export interface ConnectedDeviceSliceState {
    deviceList: ConnectedDevice[]
}

const initialState: ConnectedDeviceSliceState = {
    deviceList: [],
};

export const connectedDeviceSlice  = createSlice({
    name: 'connectedDeviceList',
    initialState,
    reducers: {
        reset: (state, action) => {
            var currentDevices = state.deviceList;
            state.deviceList = currentDevices.map(item => (
                {
                    ...item,
                    online: false
                }
            ));
        },
        resetByDeviceId: (state, action) => {
            const { deviceId } = action.payload;
            var currentDevices = state.deviceList;
            state.deviceList = currentDevices.map(item => {
                if(item.id === deviceId) {
                    return {
                        ...item,
                        online: false
                    }
                } else {
                    return item;
                }
            });
        },
        update: (state, action) => {
            const { payload } = action.payload;
            state.deviceList = payload;
        }
    }
});

export const { reset, update, resetByDeviceId } = connectedDeviceSlice.actions
export default connectedDeviceSlice.reducer